import React, { useState } from 'react'

function CustomDate({ value, onChangeValue, helperText="" }) {
  
  const [boxShadow, setBoxShadow] = useState('0px 1px 2px rgba(16, 24, 40, 0.05)');

  function parseDateForWeb(dateString) {
    var date = new Date(dateString);
    return date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
  }

  return (
    <div>
      <input 
        type="date" 
        onFocus={() => {setBoxShadow("0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF")}}
        onBlur={() => {setBoxShadow("0px 1px 2px rgba(16, 24, 40, 0.05)")}}
        onChange={(e) => onChangeValue(new Date(e.target.value).toLocaleDateString())}
        value={parseDateForWeb(value)}
        style={{
          backgroundColor: '#FFFFFF',
          borderStyle : "solid",
          borderColor : helperText === "" ? "#D0D5DD" : "red",
          borderWidth : 1,
          borderRadius: 8,
          padding : 10,
          outline: 'none',
          boxShadow : boxShadow,
          width: "100%" ,
        }}
      />
      <p style={{color:"red", fontSize: "1.4rem"}}>{helperText}</p>
    </div>
  )
}

export default CustomDate